import getQueryParams from './getQueryParams';

const hasQueryParam = name =>
  Object.prototype.hasOwnProperty.call(getQueryParams(), name);

export default hasQueryParam;